{
  "remove": "Usuń"
}
